module.exports = __webpack_public_path__ + "static/media/details.7dfa494e.svg";